import { useQuery } from '@tanstack/react-query'

import { Observation } from '../../types/observation'
import { get } from '../../utils/api'

export const useObservation = (observationId?: number) =>
  useQuery(
    ['observations', observationId],
    () =>
      observationId
        ? get<Observation>(`/observations/${observationId}/`)
        : undefined,
    {
      retry: false,
    }
  )
